/**
 * Round values so they sum to exactly {@link target} at {@link decimals} precision.
 *
 * Uses the largest-remainder method: floor all values, then distribute the
 * residual one unit at a time to the items with the largest fractional parts.
 */
export function largestRemainderRound(values: number[], decimals = 1, target = 100): number[] {
  if (values.length === 0) {
    return values;
  }
  const factor = Math.pow(10, decimals);
  const scaled = values.map((v) => v * factor);
  const floored = scaled.map((s) => Math.floor(s));
  const remainders = scaled.map((s, i) => s - floored[i]);
  const residual = Math.round(target * factor) - floored.reduce((a, b) => a + b, 0);
  const indices = remainders
    .map((r, i) => ({ r, i }))
    .sort((a, b) => b.r - a.r)
    .map((x) => x.i);
  for (let j = 0; j < Math.max(residual, 0); j++) {
    floored[indices[j]] += 1;
  }
  return floored.map((f) => f / factor);
}
